import api from './interceptor';

const BASE_URL_V1 = 'api/v1/auth';

export default {
  // API Version 1
  signup: params => api.post(`${BASE_URL_V1}/signup`, params),
  login: params => api.post(`${BASE_URL_V1}/login`, params),
  logout: params => api.post(`${BASE_URL_V1}/logout`, params),
  getAuthByToken: ({ token }) => api.get(`${BASE_URL_V1}/validate-sign-in-token/${token}`),
  changeUsersPassword: params => api.post(`${BASE_URL_V1}/change-users-password`, params),
  forgotPassword: params => api.post(`${BASE_URL_V1}/forgotPassword`, params),
  changePassword: params => api.post(`${BASE_URL_V1}/changePassword`, params),
  confirmationGet: token => api.get(`${BASE_URL_V1}/confirmation/${token}`),
  fetchPrefieldData: prefieldToken => api.get(`${BASE_URL_V1}/prefield/${prefieldToken}`),
  readClinicSettings: clinicId => api.get(`${BASE_URL_V1}/signup/settings/${clinicId}`),
  urlForPillarSubscription: (clinicId, params) => api.post(`${BASE_URL_V1}/signup/payment-form/${clinicId}`, params),
};
